// extracted by mini-css-extract-plugin
export default {"Black":"#333D47","recipeList":"G316087","recipeListText":"Ge6b05b","item":"G32f5f6"};